import { useCallback } from "react"
import { z } from "zod"
import { VatRateItem } from "@bundles/basket/models"
import { useCustomPartSchema } from "./useCustomPartSchema"
import { OwnArticleRequest } from "../CustomPartEditDialog"

export const useMapOwnArticleRequest = (vatRateItems: VatRateItem[]) => {
    const schema = useCustomPartSchema()

    return useCallback(
        (data: z.infer<typeof schema>): OwnArticleRequest => {
            const { note: noteToSave, ...articleData } = data

            const addCustomArticleRequest: OwnArticleRequest = {
                categoryId: articleData.categoryId!,
                selectedVatRate: vatRateItems.find((item) => item.vatRate.vatType === articleData.vatType)?.vatRate || vatRateItems[0].vatRate,
                articleNumber: articleData?.partNumber,
                customArticleListId: articleData.customArticleListId,
                isDefaultForCategory: articleData.isDefaultForCategory,
                purchasePrice: articleData.regularPrice,
                retailPrice: articleData.regularPriceWithSurcharge,
                description: articleData.description,
            }

            return addCustomArticleRequest
        },
        [vatRateItems]
    )
}
